import React, { Component } from 'react';
import Email from './main-components/email.js'
import '../css/contacto.css'

export default class Contacto extends Component {
	constructor(props) {
		super(props);
		
		this.handleChange = this.handleChange.bind(this);
		this.sendMail = this.sendMail.bind(this);
		
		this.state = {
			nombre: '',
			correo: '',
			empresa: '',
			asunto: '',
			servicio: '',
			mensaje: ''
		};
	}
	
	handleChange(e) {
		const name = e.target.name;
		const value = e.target.value;
		this.setState({[name]: value});
	}
	
	sendMail(e) {
		e.preventDefault();
		
		const subject = "Contacto del sitio web RMP Site";
		
		const body = `
			Nombre: ${this.state.nombre}
			Correo: ${this.state.correo}
			Empresa: ${this.state.empresa}
			Asunto: ${this.state.asunto}
			Servicio: ${this.state.servicio}
			Mensaje: ${this.state.mensaje}
		`;
		
		const from = 'yairjb@hotmail.com';
		const to = 'yairjb@hotmail.com';
		
		const smtp = 'smtp-mail.outlook.com';
		const nm = 'yairjb@hotmail.com';
		const ps = 'nintendohotmail';
		const token = 'ffe3e9df-be89-445c-b154-de60ddd03b09';
		
		Email.send(
			from,
			to,
			subject,
			body,
			{token: 'ffe3e9df-be89-445c-b154-de60ddd03b09'}
		);
		
		document.getElementById("success-mail").classList.remove('success-mail-close');
		document.getElementById("success-mail").classList.add('success-mail-open');
		
		this.setState({
			nombre: '',
			correo: '',
			empresa: '',
			asunto: '',
			servicio: '',
			mensaje: ''
		});
	}
	
	close(){
		document.getElementById("success-mail").classList.add('success-mail-close');
		document.getElementById("success-mail").classList.remove('success-mail-open');
	}
	
	render() {
		const servicio = [
			"Venta",
			"Demolición",
			"Excavación",
			"Nivelación",
			"Compactación",
			"Limpieza",
			"Otros"
		]
		return (
			<div id="contacto">
				<form id="form-contacto" onSubmit={this.sendMail}>
					<div className="contacto-left">
						<label>VISÍTANOS</label>
						<div className="contacto-recuadro">
							<p>¿Tienes preguntas o necesitas una cotización?</p>
							<p>¡No dudes en contactarnos!. Estamos disponibles las 24 horas para atenderte.</p>
							<br/>
							<p>INFORMACIÓN DE CONTACTO</p>
							<p><img
								src="../img/resources/ICONO-TELEFONO.png"
								className='contacto-tel'
								alt="phone" /> 
								5873 1606 / 5871 8615</p>
							<p><img
								src="../img/resources/ICONO-CORREO.png"
								className='contacto-mail'
								alt="mail" />rmp800218@hotmail.com</p>
							<br/>
							<p>Pantano 54, Colonia Atlanta </p>
							<p>Cuautitlán Izcalli</p>
							<p>Estado de México, México</p>
						</div>
					</div>
					<div className="contacto-right">
						<input
							type="text"
							name="nombre"
							ref="nombre"
							className="first"
							placeholder="Nombre:"
							value={this.state.nombre}
							onChange={this.handleChange}
							required
						/>
						<input
							type="email"
							name="correo"
							ref="correo"
							placeholder="Correo Electrónico:"
							value={this.state.correo}
							onChange={this.handleChange}
							required
						/>
						<input
							type="text"
							name="empresa"
							ref="empresa"
							placeholder="Empresa:"
							value={this.state.empresa}
							onChange={this.handleChange}
							required
						/>
						<input
							type="text"
							ref="asunto"
							name="asunto"
							placeholder="Asunto:"
							value={this.state.asunto}
							onChange={this.handleChange}
							required
						/>
						<select
							name="servicio"
							ref="servicio"
							value={this.state.servicio}
							onChange={this.handleChange}
						>
							<optgroup selected label="servicio de interés">
							{servicio.map((name) => (
								<option key={name} value={name}>{name}</option>
							))}
							</optgroup>
						</select>
						<textarea
							name="mensaje"
							ref="mensaje"
							placeholder="Mensaje:"
							value={this.state.mensaje}
							onChange={this.handleChange}
							required
						>
						</textarea>
						<input 
							type="submit" 
							value="ENVIAR MENSAJE" 
							className="button-mail"
						/>
					</div>
					
				</form>
				<div id="success-mail" onClick={this.close}>
					<p>Hemos recibido su mensaje, en un momento nos comunicaremos con usted, gracias.</p>
					<img
						src="../img/resources/x.png"
						alt="cerrar"
					/>
				</div>
				<div className="map-link">
					<a href="https://goo.gl/maps/tcFRAXJpYVL2" target="_blank">
						<img
							src="../img/resources/MAPS-ICONO.png"
							alt="cerrar"
						/>
					</a>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/contacto.js